export default "__VITE_ASSET__6af54a8d__"